import Header from "../components/Header";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom";
import { MascaraCpf } from "../../utils/MascaraCpf";
import { MascaraTelefone } from "../../utils/MascaraTelefone";
import { MascaraCnpj } from "../../utils/MascaraCnpj";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { IconButton } from "@mui/material";

const usuarios = [
    {
        id: 1,
        data: "2024-06-15",
        usuario: "João Silva",
        arquivos: 5,
        processados: 4,
        pendentes: 1,
        erros: 0,
        status: "Concluído"

    }
];

export default function Index() {
    const navigate = useNavigate();
    
    const [importacoes, setImportacoes] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            axios.get(`${process.env.REACT_APP_API_URL}/listar/importacoes`, {
                headers: {
                    Authorization: token
                }
            })
                .then(response => {
                    console.log(response.data);
                    setImportacoes(response.data.importacoes);
                }
                )
                .catch(error => {
                    console.error('Erro ao buscar importações:', error);
                });
        }
    }, [navigate]);

    return (
        <div>
            <Header />
            <div style={{ width: '100%', height: '90vh', display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '90%', marginTop: 20 }}>
                    <div role="presentation">
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" onClick={() => navigate("../dashboard")}>
                                Dashboard
                            </Link>
                            <Typography sx={{ color: 'text.primary' }}>Obrigações</Typography>
                        </Breadcrumbs>
                    </div>
                    <div>
                        <h2>Obrigações</h2>
                    </div>
                    <div>
                        <h3>Histórico de Importações</h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                        <button
                            style={{
                                border: "none",
                                padding: "8px 14px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontSize: "13px",
                                fontWeight: 500,
                                background: "#008000",
                                color: "#fff",
                                transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) => (e.target.style.background = "#025e02ff")}
                            onMouseLeave={(e) => (e.target.style.background = "#008000")}
                            onClick={() => navigate("../obrigacoes/importar-guias")}
                        >
                            Nova Importação
                        </button>
                    </div>
                    {/* // tabela para consultar cliente */}
                    <div style={{ width: "100%", overflowX: "auto", marginTop: "20px" }}>
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                borderRadius: "12px",
                                overflow: "hidden",
                                background: "#fff",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            }}
                        >
                            <thead style={{ background: "#0b243d", color: "#fff" }}>
                                <tr>
                                    {["ID", "Data", "Usuário", "Arquivos", "Processados", "Erros", "Status", "Ação"].map((header) => (
                                        <th
                                            key={header}
                                            style={{
                                                padding: "16px 18px",
                                                textAlign: "left",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                letterSpacing: "0.5px",
                                            }}
                                        >
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {importacoes.map((importacao, i) => (
                                    <tr
                                        key={importacao?.idImportacao}
                                        style={{
                                            background: i % 2 === 0 ? "#f9f9f9" : "#fff",
                                            transition: "all 0.2s ease-in-out",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.background = "#eef3f8")}
                                        onMouseLeave={(e) =>
                                            (e.currentTarget.style.background = i % 2 === 0 ? "#f9f9f9" : "#fff")
                                        }
                                    >
                                        <td style={{ padding: "14px 18px", fontSize: "14px" }}>{importacao?.idImportacao}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px", fontWeight: 500 }}>{importacao?.criadoEm}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px", fontWeight: 500 }}>{importacao?.idUsuario}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px" }}>{importacao?.totalArquivos}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px" }}>{importacao?.processados}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px" }}>{importacao?.erros}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px" }}><span style={{ backgroundColor: importacao?.status === "FINALIZADO" ? "#07c90041" : "#ff000041", padding: "4px 8px", borderRadius: "10px", color: "black" }}><span style={{ width: "10px", height: "10px", borderRadius: "50%", background: importacao?.status === "FINALIZADO" ? "green" : "red", display: "inline-block", marginRight: "8px" }}></span>{importacao?.status}</span></td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px", display: "flex", gap: "8px" }}>
                                            <IconButton onClick={() => navigate('../obrigacoes/detalhes-importacao/' + importacao?.idImportacao)}>
                                                <ArrowForwardIosIcon />
                                            </IconButton>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}